import { Box, Typography } from '@mui/material';
import { useCallback, useContext, useMemo } from 'react';

import { PartnerContact } from '@/components/common/contact_components/PartnerContact';
import { ConfigContext } from '@/Contexts/ConfigContext';
import { LocaleContext } from '@/Contexts/LocaleContext';
import { PartnerIntakeContext } from '@/Contexts/PartnerIntakeContext';
import { ContactProps, ContactType, localizedTextEquals } from '@/models/Contact';

import RowWrap from './IntakeRowWrap';

function IntakePrimaryContact() {
  const { contactTypes } = useContext(ConfigContext);
  const { translatedText } = useContext(LocaleContext);

  const {
    primaryContact,
    countryId,
    shippingSame,
    showErrors,
    selectedProgramInfo,
    updatePrimaryContact,
    updateShippingContact,
  } = useContext(PartnerIntakeContext);

  const partnerPrimaryContactType = useMemo(
    () =>
      contactTypes.find(
        (c: ContactType) =>
          localizedTextEquals(c.contactTypeName, 'PartnerPrimary') &&
          c.programId === selectedProgramInfo.id
      ),
    [contactTypes, selectedProgramInfo.id]
  );

  const handlePrimaryContactChange = useCallback(
    (contact: ContactProps) => {
      updatePrimaryContact(contact);

      if (shippingSame) {
        updateShippingContact(contact);
      }
    },
    [updatePrimaryContact, updateShippingContact, shippingSame]
  );

  return (
    <>
      <Box display='flex' flexDirection='column' alignItems='left'>
        <Typography style={{ marginTop: '12px', marginBottom: '16px' }} variant='h3'>
          {translatedText.signup.headerPrimaryContact}
        </Typography>
      </Box>
      <RowWrap>
        <PartnerContact
          id={'partner-primary-contact'}
          contact={primaryContact}
          contactType={partnerPrimaryContactType}
          onChange={handlePrimaryContactChange}
          defaultCountryId={countryId}
          showErrors={showErrors}
          emailDisabled
        />
      </RowWrap>
    </>
  );
}

export default IntakePrimaryContact;
